export default __webpack_public_path__ + "static/media/game-of-life.7c920a93.png";